export const URL_LOGIN = "/api/login";
export const URL_LOGOUT = "/api/logout";
export const URL_VERIFY = "/api/verify";

export const URL_REGISTER = "/api/register";
export const URL_FORGET_PASSWORD = "/api/forgotPassword";
